import React from 'react';
import { Box, Typography, Avatar, Card, CardContent, Grid, Container } from '@mui/material';

const ComponentWithCards = () => {
  return (
    <Container>
      <Grid container spacing={2} alignItems="center">
        {/* Left Image Section */}
        <Grid item xs={12} md={6} className='component'>
          <Box display="flex" justifyContent="center" mb={{ xs: 2, md: 0 }}>
            <Avatar
              alt="Person"
              src="logo.png" // Add your image path
              sx={{ width: 150, height: 150 }}
            />
          </Box>
        </Grid>

        {/* Right Side with Text and Cards */}
        <Grid item xs={12} md={6}>
          <Box>
            {/* Text Section */}
            <Typography variant="h5" align="center" sx={{ mb: 2 }} className='component'>
              
            </Typography>

            {/* Cards Section */}
            <Grid container spacing={2}>
              {['Assignment Problem Statement Guide', 'Crafting Problem Statements', 'Research Assignment Problem Statements', 'Business Assignment Problem Statements'].map((text, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Card sx={{ backgroundColor: "#172554", color: "white" }}>
                    <CardContent className='component'>
                      <Typography variant="h6" color={"white"} textAlign={"center"}>
                        <i className="fa-solid fa-circle-check" style={{ paddingRight: "10px", color: "#f97316" }}></i>
                        {text}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ComponentWithCards;
